var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 4.5h15.129l-2.69-2.69L18 .75l4.5 4.5-4.5 4.5-1.06-1.06L19.628 6H4.5v5.25H3V6a1.502 1.502 0 011.5-1.5zM7.06 15.31L4.372 18H19.5v-5.25H21V18a1.502 1.502 0 01-1.5 1.5H4.371l2.69 2.69L6 23.25l-4.5-4.5 4.5-4.5 1.06 1.06z",
    fill: "#45464F"
  })));
}
export default SvgRepeat;